import { DropdownBaseQueryDto, type DropdownBaseQueryInterface } from '@zaoblako/shared/common/dtos/dropdown-base-query.dto';
import { DateRangeQueryDto, type DateRangeQueryInterface } from '@zaoblako/shared/common/dtos/date-range-query.dto';
import { TransitTaskFiltersDto, type TransitTaskFiltersInterface } from '@zaoblako/shared/modules/cctv/dtos/transit-task/transit-task-filters.dto';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { CctvDtoKeysEnum } from '@zaoblako/shared/modules/cctv/enums/cctv-dto-keys.enum';

/** Transit task list API query parameters */
export interface TransitTaskQueryInterface extends DropdownBaseQueryInterface, DateRangeQueryInterface, TransitTaskFiltersInterface {}

/** Transit task list API query parameters - DTO schema */
export const TransitTaskQueryDto = SerdeDtoClass.union<TransitTaskQueryInterface>(CctvDtoKeysEnum.TRANSIT_TASK_QUERY_DTO, [
  DropdownBaseQueryDto,
  DateRangeQueryDto,
  TransitTaskFiltersDto,
]);
